import AuthService from './AuthService';
import ApiService from "./ApiService";

class MessagesService extends ApiService {
    constructor(authService) {
        super();

        this._authService = authService;
        this._productPriceUrl = '/messages/product-price';
        this._productSellerUrl = '/messages/product-seller';
        this._CompanyMessageUrl = '/messages/company/write-to-us';
    }

    productPriceMessage(params) {
        const headers = {...this._authService.getAuthHeader(), ...this.getLangHeader()};

        return this.postResource(this._productPriceUrl, params, headers);
    }

    productSellerMessage(params) {
        const headers = {...this._authService.getAuthHeader(), ...this.getLangHeader()};

        return this.postResource(this._productSellerUrl, params, headers);
    }
    messageToCompany(params) {
        const headers = {...this._authService.getAuthHeader(), ...this.getLangHeader()};

        return this.postResource(this._CompanyMessageUrl, params, headers);
    }
}

const service = new MessagesService(AuthService);

export default service;
